/** Raccourci pour enregistrer trois actions (DEMANDE, SUCCES, ECHEC) */
export function doSuccessFailureActions(name) {
  return {
    do: name,
    success: `${name}_SUCCESS`,
    failure: `${name}_FAILURE`
  };
}



// WEBPACK FOOTER //
// ./src/redux/_utils/actions.js